<template>
  <div class="flex flex-col justify-start pb-5">
    <div class="grid grid-cols-2 items-center">
      <div class="text-xl font-bold">
        作品展示
        <button></button>
      </div>
      <div></div>
    </div>

    <!-- <div class="flex flex-row pt-5 space-x-5">
            <button  class="text-sm text-red-400" ><span>最新</span></button>
            <button class="text-sm"><span>热门</span></button> 
            <div v-for="(value, index) in contestTrack" :key="index" class="flex flex-row pl-10 space-x-5 text-base">
                <button @click="value.func" :class="currentIndex === index ? `text-blue-500 font-bold` : `text-gray-500`">{{ value.title }}</button>      
            </div> 
        </div> -->
    <div class="grid grid-cols-2 mt-3 lg:gap-5 md:gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
      <div v-for="value in projectArray" :key="value.id">
        <ShowProjectCardVue
          :id="value.id"
          :project-name="value.work_name"
          :project-type="value.work_type"
          :url="value.work_cover_url"
          :create-time="value.work_created_time"
          :work_watch_count="value.work_watch_count"
          :work_introduce="value.work_introduce"
          :user_school="value.user_school"
          open-mode="modal"
          @open="openDetail"
        />
      </div>
    </div>

    <div v-if="projectArray.length == 0" class="flex flex-col justify-center items-center">
      <el-empty description="作品内容为空" image="/img/empty.png" :image-size="44" />
      <el-button type="primary" size="small" @click="refreshWindowLocation">刷新</el-button>
    </div>

    <WorkDetailDialog v-model="detailVisible" v-model:activeId="activeWorkId" :works="projectArray" />

    <!-- 分页器 -->
    <div class="flex flex-col justify-center items-center pt-5 pb-10">
      <el-pagination
        v-model="currentPage"
        @update:current-page="handleCurrentChange"
        :hide-on-single-page="true"
        :page-size="8"
        size="small"
        background
        layout="prev, pager, next"
        :total="totalPage"
        class="mt-4"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLoginInfo } from '~/stores/user/loginInfo'
import ShowProjectCardVue from './components/ShowProjectCard.vue'
import WorkDetailDialog from '~/components/Gallery/WorkDetailDialog.vue'

export interface WorkList {
  id: number
  user_school: string
  work_name: string
  work_cover_url: string
  work_type: number
  work_watch_count: number
  work_created_time: string
  work_introduce: string
}

const projectArray = ref<WorkList[]>([])

const loginInfo = useLoginInfo()
const currentPage = ref(1)
const totalPage = ref(1)

const detailVisible = ref(false)
const activeWorkId = ref<number>()

const openDetail = ({ id }: { id: number }) => {
  activeWorkId.value = id
  detailVisible.value = true
}

/**
 * 获取分页的数量
 */
const getPageSize = async (totalPage: any) => {
  // 请求的内容
  const obj = {
    url: RequestAPI.GET_WORK_LIST,
    body: {
      page: currentPage.value,
      size: 8,
      platform: loginInfo.platform,
    },
  }

  const { data, status, error } = await postRequired(obj)
  if (data.value && (data.value || data.hasOwnProperty('data'))) {
    totalPage.value = data.value.data.total
    projectArray.value = data.value.data.workList
    return totalPage
  }
  return totalPage
}

onMounted(() => {
  nextTick(() => {
    getPageSize(totalPage)
  })
})

/**
 * 处理 current-page的切换 实现分页的请求
 */
const handleCurrentChange = async (val: number) => {
  console.log(`current page: ${val}`)
  currentPage.value = val
  await getPageSize(totalPage)
  detailVisible.value = false
  activeWorkId.value = undefined
}
</script>

<style></style>
